export function section02(windowWidth) {
    if (windowWidth > 900) {
        gsap.from(".section#section-2 .image", {
            width: "0",
            // duration : 5,
            scrollTrigger: {
                trigger: ".section#section-2",
                start: "top 85%",
                end: "top 5%",
                scrub: true,
                once: false,
            },
        })
    }

    gsap.timeline({
        scrollTrigger: {
            trigger: ".section#section-2",
            start: "top 85%",
            end: "top 5%",
            scrub: true,
            once: false,
        },
    })
        .from(".section#section-2 .copy-wrapper .title", {
            opacity: 0,
        })
        .from(
            ".section#section-2 .copy-wrapper h2",
            {
                opacity: 0,
            },
            ">-0.25"
        )
        .from(
            ".section#section-2 .copy-wrapper .content *",
            {
                opacity: 0,
                stagger: 0.15,
            },
            ">-0.25"
        )
}
